/**
 * Optimierungs-Serving-Gate, Frontend-Spiegel (26.08.2026).
 *
 * Die Regel lebt in supabase/functions/_shared/gmc-disapprovals.ts
 * (CONTENT_HEALABLE_ISSUES + optimizationServingGateOr). Frontend und Edge Function
 * koennen kein Modul teilen; der Test servingGate.test.ts liest die Edge-Datei per fs
 * und faengt eine Drift. Aendert sich die Liste dort, muss sie hier nachgezogen werden.
 *
 * Wozu die Zahl: der Optimieren-Knopf darf nie mehr versprechen, als der Server
 * auswaehlt -- enqueue-optimization-batches filtert seit dem Gate abgelehnte Produkte
 * ohne heilbares Issue heraus, also muss der Zaehler dasselbe tun.
 */
export const CONTENT_HEALABLE_ISSUES = ['item_missing_required_attribute'] as const;

/** PostgREST-`or`-Ausdruck der ERLAUBTEN Zeilen (ov = Overlap, "mindestens eines"). */
export const OPTIMIZATION_SERVING_GATE_OR =
  `shopping_ads_disapproved_at.is.null,shopping_ads_issues.ov.{${CONTENT_HEALABLE_ISSUES.join(',')}}`;
